// extracted by mini-css-extract-plugin
export default {"container":"starter_container__8au0A","title":"starter_title__z-0-j","record-label":"starter_record-label__xtuLO"};